module.exports = __webpack_public_path__ + "static/img/mfzc.79077b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mfzc.jpg
// module id = EMO7
// module chunks = 4